import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {menu_template} from "../../../common/js/vnKnockoutJsTemplates/menu_template";
import {userSection_template} from "./userSection_template";

declare var ko: any;

export class appHeader_template extends vnTemplate{

    protected menu : menu_template;
    protected userSection : userSection_template;

    protected getTemplateHtml(): string {

        return `

            <ul class="secondary-nav">
                <li class="main-nav-item dropdown hightlight only-mobile">
                    <label class="display-toggle-container">
                        <input type="checkbox" class="display-toggle-input" id="toggleViewport" data-bind=", event: {change: onToggleDeviceViews}, checked: deviceViewsToggle">
                        <span class="display-toggle-slider"></span>
                        <span class="display-toggle-icon icon i-mobile"></span>
                        <span class="display-toggle-icon icon i-desktop"></span>
                    </label>
                </li>
                <li class="main-nav-item dropdown">
                    <a class="main-nav-link icon i-settings"><span class="hidden-text">Settings</span></a>
                    <ul class="dropdown-list">
                        <li class="main-nav-item" data-bind="visible: defaultSettingsUrl()">
                            <a data-bind="attr: {href: defaultSettingsUrl()}" class="main-nav-link icon i-user">Account Settings</a>
                        </li>
                        <li class="main-nav-item" data-bind="visible: $data.isLogsVisible()">
                            <a href="/logs/" class="main-nav-link icon i-log">logs</a>
                        </li>
                        <li class="main-nav-item mobile-only" data-bind="visible: $data.isUserSectionVisible()">
                            ` + this.userSection.getHtmlBuild() + `
                        </li>
                        <li class="main-nav-item">
                            <a class="main-nav-link icon i-logout" data-bind="event: { click: onClickLogOutAction}" type="button">Logout</a>
                        </li>
                    </ul>
                </li>
                <li class="main-nav-item mobile-hidden" data-bind="visible: $data.isUserSectionVisible()">
                    ` + this.userSection.getHtmlBuild() + `
                </li>

                <div class="w-toast theme-dark" data-bind="css: {'is-visible' : showPlanPromo()}" role="region" tab-index="-1" aria-label="Notifications">
                    <div class="toast plus" role="dialog" tabindex="0">
                        <button class="toast-dismiss icon i-close" type="button" data-bind="event: { click: onClosePlanPromo }"><span class="hide">close</span></button>
                        <div class="toast-icon plus-icon-glow-neutral">
                            <img src="/assets/images/plus-app-icon.png" alt="Sentinel Plus Logo" height="auto" width="64" />
                        </div>
                        <div class="toast-content">
                            <div class="toast-message">
                                <p>Upgrade your subscription for full access!</p>                                
                            </div>
                        </div>
                        <div class="toast-actions">
                            <button type="button" data-bind="event: { click: onLearnMorePlanPromo }" class="plus-btn subtle">Learn More</button>
                            <!-- ko if: isOwnerOrAdmin() -->
                                <button type="button" data-bind="event: { click: onUpgradePlanPromo }" class="plus-btn">Upgrade</button>
                            <!-- /ko -->
                        </div>
                    </div>
                </div>

            </ul>

            <div class="w-dialog changelog theme-light" data-bind="css: {'is-visible': showReleaseLogsWindow() == true}" role="dialog" tab-index="-1">
                    <div class="dialog-container">
                        <div class="dialog-inner">
                            <div class="dialog-aside theme-dark">
                                <!-- ko if: releaseLogsToShow()[currentReleaseLogIndex()] && releaseLogsToShow()[currentReleaseLogIndex()].imageUrl != null -->
                                    <div class="feature-preview-figure">
                                        <img data-bind="attr: {src: releaseLogsToShow()[currentReleaseLogIndex()].imageUrl}" />
                                    </div>
                                <!-- /ko -->
                                <div class="feature-preview-fallback">
                                    <img src="/assets/images/releases-fallback.png" alt="SentinelPro New Release Graphic" width="264" />
                                </div>
                            </div>
                            <div class="dialog-header">
                                <div class="dialog-headline">
                                    <span class="dialog-badge">New</span>
                                    <h2 class="dialog-headline-title">Release notes</h2>
                                </div>
                                <button class="dialog-dismiss icon i-close" type="button" data-bind="click: onCloseReleaseLogs"><span class="hide">close</span></button>
                            </div>        
                            <div class="dialog-body">
                                <h3 class="dialog-body-title" data-bind="text: releaseLogsToShow()[currentReleaseLogIndex()] ? releaseLogsToShow()[currentReleaseLogIndex()].title : '' "></h3>
                                <div class="dialog-content" data-bind="html: releaseLogsToShow()[currentReleaseLogIndex()] ? releaseLogsToShow()[currentReleaseLogIndex()].content : '' "></div>
                            </div>
                            <!-- ko if: releaseLogsToShow().length > 1 -->
                                <div class="dialog-footer">
                                    <button type="button" class="plus-btn" data-bind="css: {'disabled': !isReleaseLogsPreviousPossible()}, click: onCycleReleaseLog.bind(this, $data, true)">Previous</button>
                                    <button type="button" class="plus-btn" data-bind="css: {'disabled': !isReleaseLogsNextPossible()}, click: onCycleReleaseLog.bind(this, $data, false)">Next</button>
                                </div>
                            <!-- /ko -->
                        </div>
                    </div>
            </div>
            `;
    }

    /* RELEASE NOTES TEMPLATE
    <p>SentinelPro just got better with etc etc</p>
    <ul>
        <li>specific feature</li>
        <li>specific feature</li>
        <li>specific feature</li>
    </ul>
    */

    protected initPartial(): void {

        this.menu = new menu_template("menu", this.getTemplateViewModel(), this.caller);
        this.userSection = new userSection_template("userSection", this.getTemplateViewModel(), this.caller)
    }

    protected getTemplateName(): string{
        return "appHeader-template";
    }

    protected getMainElementClasses(): Array<string>{
    	return ["w-justify"];
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;

        return  {   userPicture: ko.observable(""),
        			userFullName: ko.observable(""),
        			profileLink: ko.observable(""),
                    projectsCount: ko.observable(""),
                    totalEarnings: ko.observable(""),
                    isLogsVisible: ko.observable(false),
                    isUserSectionVisible: ko.observable(false),
                    device: ko.observable(""),
                    deviceView: ko.observable(""),
                    deviceViewsToggle: ko.observable(0),
                    defaultSettingsUrl: ko.observable(null),

                    isOwnerOrAdmin: ko.observable(false),
                    showPlanPromo: ko.observable(false),

                    releaseLogsToShow: ko.observableArray([]),
                    currentReleaseLogIndex: ko.observable(0),
                    showReleaseLogsWindow: ko.observable(false),
                    isReleaseLogsPreviousPossible: ko.observable(false),
                    isReleaseLogsNextPossible: ko.observable(false),
        			onClickLogOutAction: function(data, event){ huit_neuf_this.onClickLogOutAction(); },
        			onToggleDeviceViews: function(data, event){ huit_neuf_this.onToggleDeviceViews(data, event); },

                    onCloseReleaseLogs: function(){

                        return huit_neuf_this.onCloseReleaseLogs();
                    },
                    onCycleReleaseLog: function(data, isPrevious){

                        return huit_neuf_this.onCycleReleaseLog(isPrevious);
                    },
                    onClosePlanPromo: function(){

                        return huit_neuf_this.onClosePlanPromo();
                    },
                    onUpgradePlanPromo: function(){

                        return huit_neuf_this.onUpgradePlanPromo();
                    },
                    onLearnMorePlanPromo: function(){

                        return huit_neuf_this.onLearnMorePlanPromo();
                    }
                };
    }

    public onClosePlanPromo() {

        this.caller.clearPlanPromo();
    }

    public onUpgradePlanPromo() {
        
        this.caller.redirectToSubscriptionManagement();
    }

    public onLearnMorePlanPromo(){

        window.open('https://sentinelpro.com/pages/pricing');
    }

    public setIsOwnerOrAdmin(bool: boolean){

        this.getTemplateViewModel().isOwnerOrAdmin(bool);
    }

    public setShowPlanPromo(bool: boolean){

        this.getTemplateViewModel().showPlanPromo(bool);
    }

    private onCycleReleaseLog(isPrevious: boolean){

        let currentIndex = this.getTemplateViewModel().currentReleaseLogIndex();
        let nbLogs = (this.getTemplateViewModel().releaseLogsToShow() as any[]).length;

        if (isPrevious && currentIndex > 0) {

            currentIndex--;
        } else if (!isPrevious && (currentIndex < nbLogs - 1)) {

            currentIndex++;
        }

        this.getTemplateViewModel().currentReleaseLogIndex(currentIndex)
        this.updateReleaseLogsPaginationState();
    }

    private onCloseReleaseLogs() {

        this.getTemplateViewModel().showReleaseLogsWindow(false);
        const releaseLogsToShow: any[] = this.getTemplateViewModel().releaseLogsToShow();

        const cookieString = this.caller.getVnAppZone().getCookie('readReleaseLogs');
        let readReleaseLogIds = [];
        if(cookieString) {

            readReleaseLogIds = cookieString.split(',').map((id: string) => Number.parseInt(id));
        }

        let finalReadReleaseLogIds = releaseLogsToShow.map(rl => rl.id).concat(readReleaseLogIds);

        this.caller.getVnAppZone().addCookie('readReleaseLogs', finalReadReleaseLogIds);
    }

    public setReleaseLogsToShow(releaseLogs: any[]) {

        if(releaseLogs.length > 0) {

            this.getTemplateViewModel().showReleaseLogsWindow(true);
        } else {

            this.getTemplateViewModel().showReleaseLogsWindow(false);
        }

        this.getTemplateViewModel().releaseLogsToShow(releaseLogs);
        this.updateReleaseLogsPaginationState();
    }
    
    public setIsReleaseLogsPaginationPossible(isPrevious: boolean) {

        let currentIndex = this.getTemplateViewModel().currentReleaseLogIndex();
        let allLogs = (this.getTemplateViewModel().releaseLogsToShow() as any[]).length;
        let canNavigate = isPrevious ? currentIndex > 0 : currentIndex < (allLogs - 1);

        if(isPrevious) {

            this.getTemplateViewModel().isReleaseLogsPreviousPossible(canNavigate);
        } else {

            this.getTemplateViewModel().isReleaseLogsNextPossible(canNavigate);
        }
    }

    private updateReleaseLogsPaginationState(): void {

        this.setIsReleaseLogsPaginationPossible(true);
        this.setIsReleaseLogsPaginationPossible(false);
    }

    public setUserImageSrc(src: string): void{
    	this.viewModel[this.idElement].userPicture(src);
    }
    public setUserFullName(fullName: string): void{
    	this.viewModel[this.idElement].userFullName(fullName);
    }
    public setProfilePageLink(link: string): void{
    	this.viewModel[this.idElement].profileLink(link);
    }
    public setProjectsCount(projectsCount: number): void{
        this.viewModel[this.idElement].projectsCount(projectsCount);
    }
    public setTotalEarnings(totalEarnings: string): void{
        this.viewModel[this.idElement].totalEarnings(totalEarnings);
    }
    public setIsLogsVisible(isLogsVisible: boolean): void{
        this.viewModel[this.idElement].isLogsVisible(isLogsVisible);
    }

    public setIsUserSectionVisible(isUserSectionVisible: boolean): void{
        this.viewModel[this.idElement].isUserSectionVisible(isUserSectionVisible);
    }

    public setMenu(menu): void {
        this.menu.setMenus(menu)   ;
    }
    public setUser(user) : void {
        this.userSection.setUser(user);
    }

    protected onClickLogOutAction(){
    	this.caller.logOut();
    }

    protected onToggleDeviceViews(data, event){
        this.caller.changeDeviceView(event.target.checked ? 'desktop' : 'mobile');
    }

    public setDevice(device): void {
        this.viewModel[this.idElement].device(device);
    }

    public setDeviceView(deviceView): void {
        this.viewModel[this.idElement].deviceView(deviceView);
        this.viewModel[this.idElement].deviceViewsToggle(deviceView == 'desktop' ? 1 : 0);
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/appHeader_template.ts